import React, { PureComponent } from 'react';
import ICONS from '../ICONS';
import TOOLTIP from '../TOOLTIP';
import moment from 'moment';

class SYSTRAY extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {date: new Date()};
    }
    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            date: new Date()
        });
    }

    render() {
        //let fakeYear = (this.state.date.getFullYear() - 5) % 10 + 1995;
        let fakeYear = this.state.date.getFullYear();
        var timeText = moment(this.state.date).format('dddd, MMMM D') + ', ' + fakeYear;

        return <div className="win-sys-tray">
            <div>
                <img src={ICONS.SND} />
                <TOOLTIP text="Volume" />
            </div>
            <div className="win-sys-tray-time">
                {moment(this.state.date).format('h:mm A')}
                <TOOLTIP text={timeText} />
            </div>
        </div>;
    }
}

export default SYSTRAY;



// WEBPACK FOOTER //
// ./src/walleris/EXPLORE/SYSTRAY.js